import { DeleteUserBase } from "../DeleteUserBase";

/**
 * Delete a user.
 */
export const DeleteRegisteredUser = () => (<DeleteUserBase />);
